import Moment from 'moment';
import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Grid, Button } from "@material-ui/core";
import ButtonGroup from '@material-ui/core/ButtonGroup';
import { useSelector, useDispatch } from 'react-redux';
import ErrorHandling from '../ErrorHandling/ErrorHandling';
import { genfunction } from '../../helpers';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';
import Typography from '@material-ui/core/Typography';
import { red } from '@material-ui/core/colors';
import palette from '../../theme/palette'
import ExtraItemDrawer from 'components/CalendarControls/ExtraItemDrawer';
import Drawer from '@material-ui/core/Drawer';
import { actionGetExtraItems, actionResetExtraItems } from 'actions';
import DateSearch from '../DateSearch/DateSearch';
import { actionResetDisplayAreas } from 'actions';
import { withRouter } from 'react-router';
import { actionShopCartSetManageMyBooking } from 'actions';
import { actionResetBooking } from 'actions';
import GroupReservationDrawer from './GroupReservationDrawer';

const { DefaultColor, DefaultCostRateID, SearchRecordInfo, CalendarScreenMessage1, CalendarScreenMessage2 } = window['runConfig'];

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(3),
    justifyContent: "center"
  },
  content: {
    marginTop: theme.spacing(2)
  },
  list: {
    width: 400,
    fontFamily: '"Roboto", "Helvetica", "Arial", "sans-serif"'
  },
  list2: {
    width: '100%',
    fontFamily: '"Roboto", "Helvetica", "Arial", "sans-serif"'
  },
  card: {
    maxWidth: 350,
    minWidth: 300,
    margin: 10,
  },
  avatar: {
    backgroundColor: red[500],
  },
  CardHeader: {
    backgroundColor: palette.primary.light
  },
  actions: {
    display: "flex",
    justifyContent: "center",
  },
  pagination: {
    display: "flex",
    justifyContent: "center"
  }
}));

const CalendarListView = (props) => {

  const classes = useStyles();
  const dispatch = useDispatch();

  const [state, setState] = React.useState({
    right: false,
    tourEventId: 0,
    bookingTypeID: 0,
    errorMsg: '',
    pagedEvents: [],
    navigatedToDate: null,
    disablePreviousButton: true,
    isContinueToExtraItemDrawer: false,
    isContinueToGroupDrawer: false,
    organizationID: "",
    groupSize: "",
    isEditEvent: false
  });

  let tourEvents = useSelector(state => state.reducerExtraItems.extramItems);
  const errExtraItem = useSelector(state => state.reducerExtraItems.extramItemsError);
  const displayAreasState = useSelector(state => state.reducerDisplayAreas);
  const bookingTypes = useSelector(state => state.reducerBookingTypes);
  const shopcartreducer = useSelector(state => state.reducerShopCart);
  const calendarNavState = useSelector(state => state.reducerCalendarView);
  const reducerBooking = useSelector(state => state.reducerBooking);

  useEffect(() => {

    let propsEvent = props.location.event;
    if (props.Path == "/calendar/:id") {

      actionResetDisplayAreas(dispatch);
      actionGetExtraItems(dispatch, props.urlID, true, false, null, true, null);

    }
    else {

      if (displayAreasState.displayAreas !== undefined && displayAreasState.displayAreas.length > 0) {
        let newDisplayAreas = JSON.parse(JSON.stringify(displayAreasState.displayAreas));
        let newObj = { ...newDisplayAreas.filter(x => x.DisplayAreaNo == props.urlID)[0] };

        propsEvent ?
          actionGetExtraItems(dispatch, props.urlID, true, true, propsEvent.EventDate, true, null)
          :
          actionGetExtraItems(dispatch, props.urlID, true, true, newObj.NextTourDate, true, null);
      }
      else {

        propsEvent ?
          actionGetExtraItems(dispatch, props.urlID, true, true, propsEvent.EventDate, true, null)
          :
          actionGetExtraItems(dispatch, props.urlID, true, true, displayAreasState.displayArea.NextTourDate, true, null);
      }
    }
  }, []);

  useEffect(() => {

    if (!state.isEditEvent) {

      if (calendarNavState.viewType == "ListView") {
        setState({ ...state, pagedEvents: tourEvents })
      }
    }

  }, [tourEvents]);


  useEffect(() => {
    reloadEventForGroups(props.location.event);
  }, [bookingTypes, tourEvents]);

  const toggleDrawer = (side, open, event) => {

    if (event && event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }

    if (state.errorMsg.length > 0) {
      return;
    }

    if (event)
      setState({ ...state, [side]: open, tourEventId: event.TourEventID, bookingTypeID: event.BookingTypeID });
    else {

      props.location.event = null;
      setState({ ...state, [side]: open, tourEventId: 0, groupSize: "", organizationID: "", isContinueToExtraItemDrawer: false, isContinueToGroupDrawer: false, isEditEvent: false });
    }
  };

  const checkIsReloadEvent = (event) => {

    let reloadEvent = false;

    if (genfunction.IsEditEvent(bookingTypes.bookingTypes, event)) {

      if (shopcartreducer.events && shopcartreducer.events.length > 0 && shopcartreducer.events.find(x => x.TourEventID == event.TourEventID)) {
        reloadEvent = true;
        event = shopcartreducer.events.filter(x => x.TourEventID == event.TourEventID)[0];
      }

      reloadEvent ? reloadEventForGroups(event) : toggleDrawer('right', true, event);

    }
    else {
      toggleDrawer('right', true, event);
    }
  }



  const reloadEventForGroups = (event) => {

    if (event && event.hasOwnProperty("TourEventID")) {

      setState({
        ...state,
        right: true,
        tourEventId: event.TourEventID,
        bookingTypeID: event.BookingTypeID,
        selectedDate: new Date(event.EventDate),
        groupSize: event.GroupSize,
        organizationID: event.OrganizationID,
        isContinueToGroupDrawer: event.OrganizationID !== "" ? true : false,
        isEditEvent: true,
        pagedEvents: calendarNavState.viewType == "ListView" ? tourEvents : ""
      });
    }

  }

  const setIsEditEvent = (value) => {
    setState({
      ...state, isEditEvent: value
    });
  }

  const goToExtraItemOrGroupDrawer = (value) => {
    setState({ ...state, isContinueToExtraItemDrawer: value, isContinueToGroupDrawer: !value });
  }

  const showGroupDrawer = () => {

    const bType = bookingTypes.bookingTypes.filter(x => x.BookingTypeID == state.bookingTypeID)[0];

    if (bType && !state.isContinueToExtraItemDrawer) {
      if (bType.RequireCompanyName || bType.ShowTourProductsBasedOnGroupSize || state.isContinueToGroupDrawer)
        return true;
    }

    return false
  }

  const onChangeOrganization = (value) => {

    value ? setState({ ...state, organizationID: value.CustomerID }) : setState({ ...state, organizationID: "" })
  }

  const onChangeGroupSize = (value) => {

    value ? setState({ ...state, groupSize: value.GroupSize }) : setState({ ...state, groupSize: "" })

  }

  const sideList = side => {

    return (
      < div className={window.matchMedia("(min-width: 600px)").matches ? classes.list : classes.list2} role="presentation" >

        {showGroupDrawer() ?

          <GroupReservationDrawer goToExtraItemOrGroupDrawer={goToExtraItemOrGroupDrawer}
            ismembershipapplied={shopcartreducer.membershipValidation.ismembershipApplied}
            membercostrate={shopcartreducer.membershipValidation.membershipcostrate}
            isIDME={shopcartreducer.IDME.isIdMeApplied}
            isIDMECostrate={shopcartreducer.IDME.idmecostrate}
            organizationID={state.organizationID} groupSize={state.groupSize}
            onChangeOrganization={onChangeOrganization}
            onChangeGroupSize={onChangeGroupSize}
            bookingtypeID={state.bookingTypeID} tourEventId={state.tourEventId} toggleDrawer={toggleDrawer}
            isEditEvent={state.isEditEvent} toggleIsEdit={setIsEditEvent} isContinueToGroupDrawer={state.isContinueToGroupDrawer}
          />
          :
          <ExtraItemDrawer tourEventId={state.tourEventId}
            ismembershipapplied={shopcartreducer.membershipValidation.ismembershipApplied}
            membercostrate={shopcartreducer.membershipValidation.membershipcostrate}
            isIDME={shopcartreducer.IDME.isIdMeApplied}
            isIDMECostrate={shopcartreducer.IDME.idmecostrate}
            bookingtypeID={state.bookingTypeID} callCheckout={constredirect}
            toggleDrawer={toggleDrawer} isEditEvent={state.isEditEvent}
            groupSize={state.groupSize} organizationID={state.organizationID}
            goToExtraItemOrGroupDrawer={goToExtraItemOrGroupDrawer} isContinueToExtraItemDrawer={state.isContinueToExtraItemDrawer}
          />

        }
      </div >)
  };

  const constredirect = (products) => {
    props.constredirect(products);
  }

  const errorcancelhandle = () => {
    actionResetExtraItems(dispatch);
    setState({ ...state, right: false, errorMsg: '' });
  }

  const onPageChange = (event, page) => {
    var startIndex = (page - 1) * 7;
    var endIndex = (startIndex + 7) > tourEvents.length ? (tourEvents.length) : (startIndex + 7)
    setState({ ...state, pagedEvents: tourEvents.slice(startIndex, endIndex) })
  }

  const enableDisablePreviousButton = (startDate) => {
    var today = Moment(new Date()).format('YYYY-MM-DD');
    if (startDate <= today) {
      return true;
    }
    else {
      return false;
    }
  }

  const GetSearchDays = () => {
    if (displayAreasState && displayAreasState.isDisplay) {
      return displayAreasState.displayArea ? displayAreasState.displayArea.ListViewSearchDays : 0;
    }
    else {
      return bookingTypes.bookingType ? bookingTypes.bookingType.ListViewSearchDays : 0;
    }
  }

  function GetFilterDates(startDate) {
    var disable = enableDisablePreviousButton(startDate);
    setState({ ...state, disablePreviousButton: disable });
    props.onFilter(startDate);
  }

  const onNavigation = (startDate) => {
    var disable = enableDisablePreviousButton(startDate);
    setState({ ...state, navigatedToDate: startDate, disablePreviousButton: disable });
    props.onFilter(startDate);
  }

  const GetDefaultCostRate = (PriceMatrix) => {
    let pamtrix = undefined;
    let costrate = DefaultCostRateID;

    if (shopcartreducer.membershipValidation.ismembershipApplied) {
      costrate = shopcartreducer.membershipValidation.membershipcostrate;
    }

    if (shopcartreducer.IDME.isIdMeApplied) {
      costrate = shopcartreducer.IDME.idmecostrate;
    }

    if (PriceMatrix.length > 1) {
      pamtrix = PriceMatrix.find(x => x.CostRateID == costrate);
    }
    else {
      pamtrix = PriceMatrix && PriceMatrix.length > 0 ? PriceMatrix[0] : undefined;
    }

    return pamtrix;
  }

  const CheckShowAvailability = (availableSeats, bookingTypeID) => {

    let bookingType = bookingTypes.bookingTypes.find(x => x.BookingTypeID == bookingTypeID);

    if (bookingType !== undefined && bookingType.ShowAvailability) {
      return '(' + availableSeats + ' ' + bookingType.AvailabilityText + ')';
    }

    return '';
  }

  const WebDisplayName = (webName, bookingTypeID) => {

    let bookingType = bookingTypes.bookingTypes.find(x => x.BookingTypeID == bookingTypeID);

    return bookingType ? webName : '';
  }

  const redirecttoconfirmbookingchanges = (event) => {

    if (shopcartreducer.managemybooking && reducerBooking.booking[0]) {

      if (reducerBooking.booking[0].TourEventID !== event.TourEventID) {
        props.history.push({
          pathname: '/confimbookingchanges',
          eventID: event.TourEventID,
          ismembershipapplied: shopcartreducer.membershipValidation.membershipcostrate,
          membercostrate: shopcartreducer.membershipValidation.membershipcostrate,
          bookingtypeID: event.BookingTypeID

        })
      }
    }
  }

  const constredirecttofindmybpooking = () => {
    actionResetBooking(dispatch);
    actionShopCartSetManageMyBooking(dispatch, false, false);

    props.history.push({
      pathname: '/findmybooking'
    })

  }

  const EventIsSaleAble = (event) => {
    if (event && event.BookNowOption != 'Book Now') {
      return true;
    }

    if (shopcartreducer.managemybooking && reducerBooking.booking[0]) {

      if (reducerBooking.booking[0].TourEventID === event.TourEventID) {
        return true;
      }
    }

  }
  return (
    <div>

      <Grid container className={classes.root + " " + classes.content}>

        {<ErrorHandling msg={errExtraItem.length > 0 ? errExtraItem : state.errorMsg}
          open={errExtraItem.length > 0 || state.errorMsg != "" ? true : false}
          handleclose={errorcancelhandle} />}

        {shopcartreducer.managemybooking && reducerBooking.booking[0] && reducerBooking.booking[0].hasOwnProperty('AllowDateTimeChanges') && !reducerBooking.booking[0].AllowDateTimeChanges ?
          <>
            <Grid item align="center" xs={12} ms={12} lg={12}>

              <Typography variant="h4" style={{ padding: "10px" }} >
                {reducerBooking.booking[0].hasOwnProperty('NoChangesMessage') ? reducerBooking.booking[0].NoChangesMessage : 'Date Time Changes are not allowed.'}
              </Typography>
              <Button variant="outlined" size="medium" color="primary"
                style={{ padding: "10px" }}
                onClick={() => constredirecttofindmybpooking()}>
                Cancel Changes
              </Button>
            </Grid>
          </>
          :
          <>
            {state.pagedEvents !== undefined
              && state.pagedEvents.length > 0
              ?
              <DateSearch SearchDates={GetFilterDates}
                defaultDate={state.pagedEvents !== undefined
                  && state.pagedEvents[0].hasOwnProperty("EventEndDateTime") && state.navigatedToDate == null
                  ?
                  Moment(state.pagedEvents[0].EventEndDateTime).format('YYYY-MM-DD')
                  : Moment(state.navigatedToDate).format('YYYY-MM-DD')} />
              : null}

            {shopcartreducer.managemybooking ?
              <Grid item align="center" xs={12} ms={12} lg={12}>

                <Typography variant="h4" style={{ padding: "10px" }} >
                  {CalendarScreenMessage1} {Moment(reducerBooking.booking[0].EventStartDateTime).format('dddd,MMMM D')} at  {Moment(reducerBooking.booking[0].EventStartDateTime).format('LT')} {CalendarScreenMessage2}
                </Typography>
                <Button variant="outlined" size="medium" color="primary"
                  style={{ padding: "10px" }}
                  onClick={() => constredirecttofindmybpooking()}>
                  Cancel Changes
                </Button>
              </Grid> : null}


            {state.pagedEvents !== undefined &&
              state.pagedEvents.length > 0
              && state.pagedEvents[0].hasOwnProperty("EventEndDateTime") ?

              state.pagedEvents.map((e, i) => {

                if (e.BookNowOption === "Past Event" || e.BookNowOption === "Cancelled") {
                  return null;
                }

                else if (e.TourDisplayDays && e.TourDisplayDays > 0) {
                  let lastdisplaydate = new Date(e.CurrentDateTimeAtLocation);
                  lastdisplaydate.setDate(lastdisplaydate.getDate() + e.TourDisplayDays);
                  if (new Date(e.EventStartDateTime) > lastdisplaydate)
                    return null;
                }

                return e.BookNowOption !== "Past Event" && e.BookNowOption !== "Cancelled" ?

                  <Card className={classes.card} key={e.TourEventID}>
                    <CardHeader style={{ backgroundColor: e.DisplayColor !== undefined && e.DisplayColor.length > 0 ? e.DisplayColor : DefaultColor }}
                      title={
                        <Typography variant="h5" color="textPrimary"
                          component="p">{Moment(e.EventStartDateTime).format('MMMM DD, YYYY')}</Typography>

                      }
                      subheader={
                        <Typography variant="subtitle1" color="textSecondary"
                          component="p">{Moment(e.EventStartDateTime).format('dddd hh:mm a') + ' - ' + Moment(e.EventEndDateTime).format('hh:mm a')}</Typography>
                      }
                    />
                    <CardContent>
                      <Typography variant="h4" color="textSecondary" component="p">
                        {WebDisplayName(e.EventName, e.BookingTypeID)}
                      </Typography>

                      {e.TourProducts && e.TourProducts.length > 0 && e.TourProducts.map(product =>
                        <Typography variant="body2" color="textSecondary" component="p" key={product.TourProductID}>

                          {product.ShowOnCalendar && product.AffectsCapacity && product.hasOwnProperty('PriceMatrix') && product.PriceMatrix !== undefined && GetDefaultCostRate(product.PriceMatrix) !== undefined ?
                            '    ' + product.TourProductName + ' '
                            + genfunction.ccyFormat(GetDefaultCostRate(product.PriceMatrix).Price)
                            : null}

                        </Typography>
                      )}

                      {e.TourProducts && e.TourProducts.length > 0 && e.TourProducts.map(product =>
                        <Typography variant="body2" color="textSecondary" component="p" key={product.TourProductID}>

                          {product.ShowOnCalendar && product.AffectsCapacity == false && product.hasOwnProperty('PriceMatrix') && product.PriceMatrix !== undefined && GetDefaultCostRate(product.PriceMatrix) !== undefined ?
                            '    ' + product.TourProductName + ' '
                            + genfunction.ccyFormat(GetDefaultCostRate(product.PriceMatrix).Price)
                            : null}

                        </Typography>
                      )}

                      {e.BookNowOption === 'Book Now' ?
                        <Typography variant="h5" color="textSecondary" component="p">
                          {CheckShowAvailability(e.SeatsAvailable, e.BookingTypeID)}
                        </Typography>
                        : null}
                    </CardContent>

                    <CardActions className={classes.actions}>
                      <Button variant="contained" color="primary" onClick={() => shopcartreducer.managemybooking ? redirecttoconfirmbookingchanges(e) :
                        checkIsReloadEvent(e, 'right', true)} disabled={EventIsSaleAble(e)} >{e.BookNowOption}</Button>
                    </CardActions>
                  </Card>
                  : null
              })

              :
              <Typography variant="h5" color="textSecondary" component="p">
                {SearchRecordInfo}
              </Typography>
            }

            <div>
              <Drawer anchor="right" open={state.right} onClose={() => toggleDrawer('right', false)}>
                {sideList('right')}
              </Drawer>
            </div>
            <Grid item xs={12} ></Grid>
            <ButtonGroup variant="outlined" color="primary" aria-label="text primary button group">
              {state.disablePreviousButton == true ?
                <Button style={{ width: 100 }} onClick={() => onNavigation(genfunction.RemoveSevenDays(tourEvents, GetSearchDays(), document.getElementById("fromDate").value))} disabled>Previous</Button> :
                <Button style={{ width: 100 }} onClick={() => onNavigation(genfunction.RemoveSevenDays(tourEvents, GetSearchDays(), document.getElementById("fromDate").value))}>Previous</Button>}

              {state.pagedEvents !== undefined &&
                state.pagedEvents.length > 0
                && state.pagedEvents[0].hasOwnProperty("EventEndDateTime") ?
                <Button style={{ width: 100 }} onClick={() => onNavigation(genfunction.AddNextSevenDays(tourEvents))}>Next</Button>
                : <Button style={{ width: 100 }} onClick={() => onNavigation(genfunction.AddNextSevenDays(tourEvents))} disabled>Next</Button>}
            </ButtonGroup>
          </>}
      </Grid>
    </div >
  );
}
export default withRouter(CalendarListView);
